import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {property} from 'lodash';
import {fetchFeatureFlags} from 'shared/actions/feature-flags';
import MyList from 'src/components/CollegeSearch/MyList/MyList';
import {
  receiveEarnings,
  receiveEarningsOrder,
  updateEarningsOrder,
} from 'shared/college-earnings/actions/college-earnings';
import {getUserInfo} from 'src/redux/collegeSearch/actions';
import {fetchAdmissionLikelihoodScores} from 'high-school-student/college-earnings/actions/admission-likelihood';
import {selectApplicationManagementProps} from 'shared/application-management/selectors';
import {
  getCollegeAppStatuses,
  setCollegeAppStatus,
} from 'shared/college-application-status/actions/college-application-status';

const mapStateToProps = ({
  admissionLikelihood = {},
  collegeApplicationStatuses = {},
  collegeEarnings,
  student,
}) => {
  const courses = property('portfolio.courses')(student) || [];

  return {
    collegeApplicationStatuses,
    studentId: student._id,
    ...selectApplicationManagementProps({
      admissionLikelihood,
      collegeApplicationStatuses,
      collegeEarnings,
      courses,
      student,
      filterByAppStatus: true,
    }),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      receiveEarnings,
      setCollegeAppStatus,
      getCollegeAppStatuses,
      getUserInfo,
      fetchAdmissionLikelihoodScores,
      fetchFeatureFlags,
      receiveEarningsOrder,
      updateEarningsOrder,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MyList);
